import 'src/styles/ui/input.css';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * Textarea Component - multi-line sibling of Input, sharing the same rounded
 * field styling. All native textarea props pass through.
 */
const Textarea = ({ className, ...props }) => (
  <textarea className={classNames('input-field', 'input-field--area', className)} {...props} />
);

Textarea.propTypes = {
  className: PropTypes.string,
};

Textarea.defaultProps = {
  className: null,
};

export default Textarea;
